import {convertGramsToOunces, convertGramsToPounds,
  convertGramsToStones, convertGramsToKilograms} from './GramsConversion';
import {convertOuncesToKilograms, convertOuncesToStones,
  convertOuncesToPounds, convertOuncesToGrams} from './OuncesConversion';
import {convertPoundsToKilograms, convertPoundsToStones,
  convertPoundsToOunces, convertPoundsToGrams} from './PoundsConversion';
import {convertStonesToKilograms, convertStonesToPounds, convertStonesToOunces,
  convertStonesToGrams} from './StonesConversion';
import {convertKilogramsToStones, convertKilogramsToPounds, convertKilogramsToOunces,convertKilogramsToGrams} from './KilogramsConversion';

function getFinalGramsConversion(temp,conType){
        let result = ''
        if(conType==='grtooz'){
          result = convertGramsToOunces(parseFloat(temp));
        }else if(conType==='grtopd'){
          result = convertGramsToPounds(parseFloat(temp));
        }else if(conType==='grtost'){
          result = convertGramsToStones(parseFloat(temp));
        }else if(conType==='grtokl'){
          result = convertGramsToKilograms(parseFloat(temp));
        }
        return result;
    }

function getFinalOuncesConversion(temp,conType){
    let result = ''
    if(conType==='oztokl'){
      result = convertOuncesToKilograms(parseFloat(temp));
    }else if(conType==='oztost'){
      result = convertOuncesToStones(parseFloat(temp));
    }else if(conType==='oztopd'){
      result = convertOuncesToPounds(parseFloat(temp));
    }else if(conType==='oztogr'){
      result = convertOuncesToGrams(parseFloat(temp));
    }
    return result;
}

function getFinalPoundsConversion(temp,conType){
    let result = ''
    if(conType==='pdtokl'){
      result = convertPoundsToKilograms(parseFloat(temp));
    }else if(conType==='pdtost'){
      result = convertPoundsToStones(parseFloat(temp));
    }else if(conType==='pdtooz'){
      result = convertPoundsToOunces(parseFloat(temp));
    }else if(conType==='pdtogr'){
      result = convertPoundsToGrams(parseFloat(temp));
    }
    return result;
}

function getFinalStonesConversion(temp,conType){
    let result = ''
    if(conType==='sttokl'){
      result = convertStonesToKilograms(parseFloat(temp));
    }else if(conType==='sttopd'){
      result = convertStonesToPounds(parseFloat(temp));
    }else if(conType==='sttooz'){
      result = convertStonesToOunces(parseFloat(temp));
    }else if(conType==='sttogr'){
      result = convertStonesToGrams(parseFloat(temp));
    }
    return result;
}

function getFinalKilogramsConversion(temp,conType){
    let result = ''
    if(conType==='kltost'){
      result = convertKilogramsToStones(parseFloat(temp));
    }else if(conType==='kltopd'){
      result = convertKilogramsToPounds(parseFloat(temp));
    }else if(conType==='kltooz'){
      result = convertKilogramsToOunces(parseFloat(temp));
    }else if(conType==='kltogr'){
      result = convertKilogramsToGrams(parseFloat(temp));
    }
    return result;
}


export {getFinalKilogramsConversion,getFinalStonesConversion,
  getFinalPoundsConversion,getFinalOuncesConversion,
  getFinalGramsConversion};
